<app-modal-template
	[title]="'Download Users'"
	(cancelClicked)="cancel()"
	(saveClicked)="downloadFile()"
	[showCancel]="false"
	[saveText]="'Download'"
	[saveIcon]="['fass', 'arrow-to-bottom']"
>
	<p>Click the button below to download a list of users in .CSV format.</p>

	<mat-slide-toggle id="download-users-active-user-toggle" class="mb-md" [(ngModel)]="activeOnly"
		>Active Users Only</mat-slide-toggle
	>
</app-modal-template>
